import { showToast } from '@/utils/notifications';
import ManageCommentaire from '@/views/consultations/en-cours/consultation-commentaire/manage-consultation-commentaire';
import axios from "axios";
import $ from 'jquery';

import headerImage from '../../../../../CCA_ENV_CONF/entete.png';
import { cca_config } from '@/config';


export default {
    name: 'consultation-commentaire',
    components: {
        ManageCommentaire
    },
    props: {
        consultation: Object,
        section_name: String,
        evolution_id: Number,
        evolution_toggler: Number,
        slug: String,
        current_consultation_evolution: Number
    },
    data() {
        return {
            is_loading: true,
            is_empty: false,

            comment_selected: {},
            headerImage: headerImage,
            filename: '',
            font_size: 'font-14',

            selectedCommentaire: undefined,
            isSharingCommentaire: false,
        }
    },

    watch: {
        evolution_toggler() {
            this.refreshCommentaire()
        }
    },

    computed: {
        consultation_commentaires() {
            return this.$store.getters["consultation_commentaires"]
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        evolution_id_initiale() {
            return this.$store.getters['evolution_id_initiale']
        },

        patient(){
            return this.$store.getters['patient'];
        },

        selected_consultation_encours() {
            return this.$store.getters['selected_consultation_encours']
        },
    },

    mounted() {
        this.refreshCommentaire()   // Consultation commmentaires
    },

    methods: {
        refreshCommentaire() {
            this.is_loading = true 

            const data = {
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id_initiale,
                data_type: this.slug,
                est_encours: true
            }
            this.$store.dispatch('getConsultationInfoComplementaire', data).then(() => {
                if (this.consultation_commentaires.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            })
        },

        addNewComment() {
            this.comment_selected = {
                modal_title: this.section_name
            }
        },

        setCommentToEdit(comment) {
            this.comment_selected = comment
            this.comment_selected.modal_title = this.section_name
        },

        setFileName() {
            this.is_printing = true

            let tm = new Date()
            this.filename = 'Commentaire_' + this.patient.nom + ' ' + this.patient.prenoms + '_' + tm.getTime()

            setTimeout(() => {
                this.printPDF('consultationCommentPdfRef')
            }, 300);
        },

        // getFormattedDateTime(datetime) {
        //     return moment(datetime).format('[le] DD/MM/YYYY [à] HH[h]mm');
        // },

        preview(comment) {
            this.comment_selected = comment
            this.$refs['preview-comment-modal'].show()
        },

        closeCommentPreview() {
            this.$refs['preview-comment-modal'].hide()
        },

        async beforeCommentDownload({ html2pdf, options, pdfContent }) {
            await html2pdf()
                .set(options)
                .from(pdfContent)
                .toPdf()
                .get('pdf')
                .then(async (pdf) => {
                    const filename = `Commentaire_${this.patient.nom}_${this.patient.prenoms}_` + (new Date()).getTime() + '-' + this.selectedCommentaire.id + '.pdf';
                    const file = new File([pdf.output('blob')], filename, { type: 'application/pdf' });                    

                    if (this.isSharingCommentaire && this.selectedCommentaire?.id) {
                        const formData = new FormData();
                        formData.append('file', file);

                        const baseUrl = cca_config.C_URL + cca_config.C_URL_CLINIQUE_API;
                        const path = `${baseUrl}/cca-mobile/comments/${this.selectedCommentaire.id}/share`;

                        try {
                            const response = await axios.post(path, formData);

                            if (response && response.status === 200) {
                                showToast("Le commentaire a été partagé avec succès");
                            }
                        } catch (error) {
                            if (error.response) {
                                if (error.response.status === 400 || error.response.status === 422) {
                                    showToast("Erreur de requête", 'error');
                                } else if (error.response.status === 500) {
                                    showToast("Une erreur s'est produite, veuillez réessayer plus tard", 'error');
                                }
                            }
                        } finally {
                            this.isSharingCommentaire = false;
                            $('.modal').modal('hide');
                        }
                    } else {
                        pdf.save(filename);
                    }
                });
            this.is_printing = false;
        },

        async handleConfirmSharing(){
            this.comment_selected = this.selectedCommentaire;
            this.isSharingCommentaire = true;  // Action de partage activée
            this.$refs.consultationCommentPdfRef.generatePdf();  // Générez le PDF et envoyez-le
         }
    }
}


